/**
 * Pricing Intelligence API service
 *
 * Calls the zeecore /pricing-intelligence/sheets endpoints.
 */
import { API_ENDPOINTS } from '../config/api';
import { authenticatedFetch } from '../utils/authenticatedFetch';
import type { GenerateSheetParams, PricingSheet } from '../types/pricingIntelligence';

const ZEECORE = API_ENDPOINTS.base;

const jsonPost = async <T>(url: string, body: unknown): Promise<T> => {
  const res = await authenticatedFetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
  if (!res.ok) {
    let detail = '';
    try {
      const err = await res.json() as { error?: string };
      detail = err.error ? `: ${err.error}` : '';
    } catch {
      // ignore parse errors
    }
    throw new Error(`HTTP ${res.status}${detail}`);
  }
  return res.json() as Promise<T>;
};

export const generatePricingSheet = (params: GenerateSheetParams): Promise<PricingSheet> =>
  jsonPost<PricingSheet>(`${ZEECORE}/pricing-intelligence/sheets/generate`, params);
